export default __webpack_public_path__ + "static/media/dongle_arm.c0102ef9.gif";